import React, { useState } from 'react';
import { CalendarIcon, CheckCircleIcon, CircleIcon, ArrowLeftIcon, ArrowRightIcon, ClockIcon, MessageSquareIcon } from 'lucide-react';
const Calendar = () => {
  const [currentWeek, setCurrentWeek] = useState(1);
  const totalWeeks = 3;
  // Sample data - in a real app this would be dynamic
  const currentDay = 5;
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - currentDay + 1); // Set to day 1
  const generateCalendarDays = () => {
    const days = [];
    const weekStartDay = (currentWeek - 1) * 7 + 1;
    const weekEndDay = Math.min(weekStartDay + 6, 21);
    for (let i = weekStartDay; i <= weekEndDay; i++) {
      const dayDate = new Date(startDate);
      dayDate.setDate(startDate.getDate() + i - 1);
      const dayStatus = i < currentDay ? 'completed' : i === currentDay ? 'current' : 'upcoming';
      const messages = {
        1: {
          type: 'mystery',
          name: 'Misterio Sutil'
        },
        2: {
          type: 'value',
          name: 'Reconocimiento Genuino'
        },
        3: {
          type: 'nostalgia',
          name: 'Memoria Compartida'
        },
        4: {
          type: 'scarcity',
          name: 'Agenda Ocupada'
        },
        5: {
          type: 'vulnerability',
          name: 'Confesión Ligera'
        },
        6: {
          type: 'future',
          name: 'Visión Compartida'
        },
        7: {
          type: 'gratitude',
          name: 'Agradecimiento Específico'
        },
        8: {
          type: 'mystery',
          name: 'Curiosidad Intrigante'
        },
        9: {
          type: 'value',
          name: 'Crecimiento Personal'
        },
        10: {
          type: 'nostalgia',
          name: 'Sensación Familiar'
        },
        11: {
          type: 'scarcity',
          name: 'Oportunidad Limitada'
        },
        12: {
          type: 'vulnerability',
          name: 'Aprendizaje Emocional'
        },
        13: {
          type: 'future',
          name: 'Nueva Versión'
        },
        14: {
          type: 'gratitude',
          name: 'Impacto Duradero'
        },
        15: {
          type: 'mystery',
          name: 'Revelación Parcial'
        },
        16: {
          type: 'value',
          name: 'Validación Indirecta'
        },
        17: {
          type: 'nostalgia',
          name: 'Descubrimiento del Pasado'
        },
        18: {
          type: 'scarcity',
          name: 'Tiempo Pasajero'
        },
        19: {
          type: 'vulnerability',
          name: 'Reconocimiento de Error'
        },
        20: {
          type: 'future',
          name: 'Posibilidades Abiertas'
        },
        21: {
          type: 'gratitude',
          name: 'Reconocimiento Simple'
        }
      };
      const messageInfo = messages[i as keyof typeof messages];
      const messageTypeColors = {
        mystery: 'bg-purple-100 text-purple-700',
        value: 'bg-blue-100 text-blue-700',
        scarcity: 'bg-orange-100 text-orange-700',
        nostalgia: 'bg-pink-100 text-pink-700',
        vulnerability: 'bg-red-100 text-red-700',
        future: 'bg-green-100 text-green-700',
        gratitude: 'bg-yellow-100 text-yellow-700'
      };
      days.push({
        day: i,
        date: dayDate,
        status: dayStatus,
        message: messageInfo,
        typeColor: messageTypeColors[messageInfo.type as keyof typeof messageTypeColors]
      });
    }
    return days;
  };
  const calendarDays = generateCalendarDays();
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('es-MX', {
      day: 'numeric',
      month: 'short'
    });
  };
  const goToPreviousWeek = () => {
    if (currentWeek > 1) {
      setCurrentWeek(currentWeek - 1);
    }
  };
  const goToNextWeek = () => {
    if (currentWeek < totalWeeks) {
      setCurrentWeek(currentWeek + 1);
    }
  };
  return <div className="max-w-4xl mx-auto" data-id="element-74">
      <header className="mb-8 text-center" data-id="element-75">
        <h1 className="text-3xl font-bold text-[#2C2C2C] mb-2" data-id="element-76">
          Calendario Estratégico
        </h1>
        <p className="text-gray-600" data-id="element-77">Tu viaje de 21 días para la reconquista</p>
      </header>
      <div className="bg-white rounded-xl shadow-md p-6 mb-8" data-id="element-78">
        <div className="flex items-center justify-between mb-6" data-id="element-79">
          <h2 className="text-xl font-semibold text-[#2C2C2C]" data-id="element-80">
            Semana {currentWeek} de {totalWeeks}
          </h2>
          <div className="flex space-x-2" data-id="element-81">
            <button onClick={goToPreviousWeek} disabled={currentWeek === 1} className={`p-2 rounded-full ${currentWeek === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-82">
              <ArrowLeftIcon size={20} data-id="element-83" />
            </button>
            <button onClick={goToNextWeek} disabled={currentWeek === totalWeeks} className={`p-2 rounded-full ${currentWeek === totalWeeks ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-84">
              <ArrowRightIcon size={20} data-id="element-85" />
            </button>
          </div>
        </div>
        <div className="space-y-4" data-id="element-86">
          {calendarDays.map(day => <div key={day.day} className={`border rounded-lg p-4 ${day.status === 'current' ? 'border-[#E91E63] bg-pink-50' : 'border-gray-200'}`} data-id="element-87">
              <div className="flex items-center justify-between mb-3" data-id="element-88">
                <div className="flex items-center" data-id="element-89">
                  {day.status === 'completed' ? <CheckCircleIcon size={20} className="text-green-500 mr-3" data-id="element-90" /> : day.status === 'current' ? <CircleIcon size={20} className="text-[#E91E63] mr-3" fill="#E91E63" data-id="element-91" /> : <CircleIcon size={20} className="text-gray-300 mr-3" data-id="element-92" />}
                  <div data-id="element-93">
                    <h3 className="font-bold" data-id="element-94">Día {day.day}</h3>
                    <p className="text-sm text-gray-500" data-id="element-95">
                      {formatDate(day.date)}
                    </p>
                  </div>
                </div>
                <div className={`px-3 py-1 rounded-full text-xs font-medium ${day.typeColor}`} data-id="element-96">
                  Disparador{' '}
                  {day.message.type === 'mystery' ? 'Misterioso' : day.message.type === 'value' ? 'de Valor' : day.message.type === 'scarcity' ? 'de Escasez' : day.message.type === 'nostalgia' ? 'de Nostalgia' : day.message.type === 'vulnerability' ? 'de Vulnerabilidad' : day.message.type === 'future' ? 'de Futuro' : 'de Gratitud'}
                </div>
              </div>
              <div className="pl-8" data-id="element-97">
                <div className="flex items-start mb-2" data-id="element-98">
                  <MessageSquareIcon size={16} className="text-gray-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-99" />
                  <p className="text-gray-700" data-id="element-100">{day.message.name}</p>
                </div>
                <div className="flex items-start" data-id="element-101">
                  <ClockIcon size={16} className="text-gray-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-102" />
                  <p className="text-gray-700" data-id="element-103">
                    {day.day % 3 === 0 ? 'Mejor horario: Mañana (9h-11h)' : day.day % 3 === 1 ? 'Mejor horario: Tarde (14h-17h)' : 'Mejor horario: Noche (19h-22h)'}
                  </p>
                </div>
              </div>
              {day.status === 'current' && <div className="mt-3 pl-8" data-id="element-104">
                  <a href="/messages" className="inline-flex items-center text-sm font-medium text-[#E91E63] hover:text-[#D81B60]" data-id="element-105">
                    Ver mensaje recomendado{' '}
                    <ArrowRightIcon size={16} className="ml-1" data-id="element-106" />
                  </a>
                </div>}
            </div>)}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-107">
        <h2 className="text-lg font-semibold text-[#2C2C2C] mb-4" data-id="element-108">
          Consejos para el Calendario
        </h2>
        <ul className="space-y-3 text-gray-700" data-id="element-109">
          <li className="flex items-start" data-id="element-110">
            <div className="bg-pink-100 text-pink-700 p-1 rounded-full mr-3 mt-0.5" data-id="element-111">
              <span className="block h-1.5 w-1.5 rounded-full bg-current" data-id="element-112"></span>
            </div>
            <span data-id="element-113">
              Sigue la secuencia recomendada para maximizar el efecto de los
              disparadores emocionales.
            </span>
          </li>
          <li className="flex items-start" data-id="element-114">
            <div className="bg-pink-100 text-pink-700 p-1 rounded-full mr-3 mt-0.5" data-id="element-115">
              <span className="block h-1.5 w-1.5 rounded-full bg-current" data-id="element-116"></span>
            </div>
            <span data-id="element-117">
              Respeta los horarios sugeridos para cada mensaje - han sido
              calculados para el máximo impacto.
            </span>
          </li>
          <li className="flex items-start" data-id="element-118">
            <div className="bg-pink-100 text-pink-700 p-1 rounded-full mr-3 mt-0.5" data-id="element-119">
              <span className="block h-1.5 w-1.5 rounded-full bg-current" data-id="element-120"></span>
            </div>
            <span data-id="element-121">
              Si él no responde a un mensaje, espera al menos 48h antes de
              enviar el siguiente.
            </span>
          </li>
          <li className="flex items-start" data-id="element-122">
            <div className="bg-pink-100 text-pink-700 p-1 rounded-full mr-3 mt-0.5" data-id="element-123">
              <span className="block h-1.5 w-1.5 rounded-full bg-current" data-id="element-124"></span>
            </div>
            <span data-id="element-125">
              Ajusta el calendario según sea necesario en base a sus reacciones,
              pero mantén la estructura general.
            </span>
          </li>
        </ul>
      </div>
    </div>;
};
export default Calendar;